<template>
  <div class="admin-dashboard">
    <Manpower_bar />

    <v-container fluid class="pa-4 pa-md-6">
      <!-- ============================================================ -->
      <!-- HERO HEADER                                                   -->
      <!-- ============================================================ -->
      <div class="dashboard-header mb-6">
        <div class="header-content">
          <div class="header-left">
            <div class="header-icon-wrap">
              <v-icon size="36" color="white">mdi-account-group</v-icon>
            </div>
            <div>
              <h1 class="header-title">ระบบบริหารจัดการบุคลากร</h1>
              <p class="header-subtitle">
                ข้อมูล ข้าราชการ ลูกจ้างประจำ พนักงานราชการ ครูอัตราจ้าง
                ลูกจ้างชั่วคราว
              </p>
            </div>
          </div>
          <div class="header-actions">
            <v-btn
              class="action-btn green-btn"
              @click="updateData_etc()"
              depressed
            >
              <v-icon left small>mdi-refresh</v-icon>
              ปรับปรุงข้อมูล
            </v-btn>
            <v-btn
              class="action-btn blue-btn"
              :href="
                '#/college/print_report_personnel_etc/' + user.college_code
              "
              target="_blank"
              depressed
            >
              <v-icon left small>mdi-printer</v-icon>
              พิมพ์รายชื่อ
            </v-btn>
            <v-btn
              class="action-btn teal-btn"
              @click="showExportDialog = true"
              depressed
            >
              <v-icon left small>mdi-file-excel</v-icon>
              ส่งออก Excel
            </v-btn>
            <v-btn
              class="action-btn red-btn"
              @click="delFormatFail()"
              depressed
            >
              <v-icon left small>mdi-delete-sweep</v-icon>
              ลบข้อมูลไม่ถูกต้อง
            </v-btn>
          </div>
        </div>
      </div>

      <!-- ============================================================ -->
      <!-- STATS OVERVIEW CARDS                                          -->
      <!-- ============================================================ -->
      <div class="stats-grid mb-6">
        <!-- Card: รวมทั้งสิ้น -->
        <div class="stat-card stat-card--total">
          <div class="stat-card__icon">
            <v-icon size="28" color="white">mdi-account-multiple</v-icon>
          </div>
          <div class="stat-card__info">
            <span class="stat-card__value">{{
              personnel_etcsCounts.sumAll || 0
            }}</span>
            <span class="stat-card__label">รวมทั้งสิ้น (คน)</span>
          </div>
        </div>

        <!-- Card สถิติย่อย -->
        <div
          v-for="(stat, idx) in summaryCards"
          :key="'stat-' + idx"
          class="stat-card"
          :class="'stat-card--' + stat.theme"
        >
          <div class="stat-card__icon">
            <v-icon size="24" color="white">{{ stat.icon }}</v-icon>
          </div>
          <div class="stat-card__info">
            <a
              :href="'#/admin/print_personnel_etc_type/' + stat.type"
              target="_blank"
              class="stat-card__value stat-card__link"
            >
              {{ stat.count }}
            </a>
            <span class="stat-card__label">{{ stat.label }}</span>
          </div>
        </div>
      </div>

      <!-- ============================================================ -->
      <!-- CHARTS SECTION — สถิติสายการสอน & ภารกิจ                      -->
      <!-- ============================================================ -->
      <v-row class="mb-6">
        <v-col cols="12" lg="7">
          <div class="section-card">
            <div class="section-card__header">
              <v-icon color="#6366F1" class="mr-2">mdi-chart-bar</v-icon>
              <h2 class="section-title">สถิติสายการสอน ตามสาขาวิชา</h2>
              <v-spacer />
              <v-btn small text color="primary" @click="loadCourseStats()">
                <v-icon small left>mdi-refresh</v-icon> รีเฟรช
              </v-btn>
            </div>
            <div v-if="courseChartLoading" class="text-center pa-8">
              <v-progress-circular indeterminate color="#6366F1" />
              <div class="mt-2 text-caption grey--text">กำลังโหลดข้อมูล...</div>
            </div>
            <div v-else>
              <apexchart
                v-if="courseChartSeries.length > 0"
                type="bar"
                height="420"
                :options="courseChartOptions"
                :series="courseChartSeries"
              />
              <div v-else class="text-center pa-8 grey--text">
                ไม่มีข้อมูลสถิติ
              </div>
            </div>
          </div>
        </v-col>

        <v-col cols="12" lg="5">
          <div class="section-card">
            <div class="section-card__header">
              <v-icon color="#F59E0B" class="mr-2"
                >mdi-chart-donut-variant</v-icon
              >
              <h2 class="section-title">สถิติภารกิจ (กลุ่มงาน)</h2>
              <v-spacer />
              <v-btn small text color="primary" @click="loadWorkgroupStats()">
                <v-icon small left>mdi-refresh</v-icon> รีเฟรช
              </v-btn>
            </div>
            <div v-if="workgroupChartLoading" class="text-center pa-8">
              <v-progress-circular indeterminate color="#F59E0B" />
              <div class="mt-2 text-caption grey--text">กำลังโหลดข้อมูล...</div>
            </div>
            <div v-else>
              <apexchart
                v-if="workgroupChartSeries.length > 0"
                type="bar"
                height="420"
                :options="workgroupChartOptions"
                :series="workgroupChartSeries"
              />
              <div v-else class="text-center pa-8 grey--text">
                ไม่มีข้อมูลสถิติ
              </div>
            </div>
          </div>
        </v-col>
      </v-row>

      <!-- ============================================================ -->
      <!-- HELP STATS (ช่วยราชการ)                                       -->
      <!-- ============================================================ -->
      <v-expand-transition>
        <div
          v-if="helpStats.totalHelping > 0 || helpStats.totalReceiving > 0"
          class="mb-6"
        >
          <div class="section-card help-section">
            <div class="section-card__header">
              <v-icon color="#F97316" class="mr-2"
                >mdi-swap-horizontal-bold</v-icon
              >
              <h2 class="section-title">สถิติช่วยราชการ</h2>
              <v-spacer />
              <v-btn
                small
                text
                color="primary"
                @click="personnel_etcsQueryHelp()"
              >
                <v-icon small left>mdi-refresh</v-icon> รีเฟรช
              </v-btn>
            </div>

            <v-row class="mt-2">
              <v-col cols="12" sm="4">
                <div class="help-metric help-metric--out">
                  <div class="help-metric__number">
                    {{ helpStats.totalHelping }}
                  </div>
                  <div class="help-metric__label">
                    <v-icon small color="#F97316" class="mr-1"
                      >mdi-arrow-right-bold</v-icon
                    >
                    ไปช่วยราชการ
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="4">
                <div class="help-metric help-metric--in">
                  <div class="help-metric__number">
                    {{ helpStats.totalReceiving }}
                  </div>
                  <div class="help-metric__label">
                    <v-icon small color="#14B8A6" class="mr-1"
                      >mdi-arrow-left-bold</v-icon
                    >
                    รับช่วยราชการ
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="4">
                <div class="help-metric help-metric--total">
                  <div class="help-metric__number">
                    {{ helpStats.totalHelping + helpStats.totalReceiving }}
                  </div>
                  <div class="help-metric__label">
                    <v-icon small color="#6366F1" class="mr-1"
                      >mdi-sigma</v-icon
                    >
                    รวมทั้งหมด
                  </div>
                </div>
              </v-col>
            </v-row>

            <v-data-table
              v-if="helpPersonnel.length > 0"
              :headers="helpHeaders"
              :items="helpPersonnel"
              :items-per-page="10"
              class="modern-table mt-4"
              dense
            >
              <template v-slot:item.personnel_etc_help_status="{ item }">
                <v-chip
                  small
                  label
                  dark
                  :color="
                    item.personnel_etc_help_status === 'helping'
                      ? '#F97316'
                      : '#14B8A6'
                  "
                >
                  <v-icon x-small left>{{
                    item.personnel_etc_help_status === "helping"
                      ? "mdi-arrow-right-bold"
                      : "mdi-arrow-left-bold"
                  }}</v-icon>
                  {{
                    item.personnel_etc_help_status === "helping"
                      ? "ไปช่วยราชการ"
                      : "รับช่วยราชการ"
                  }}
                </v-chip>
              </template>
            </v-data-table>
          </div>
        </div>
      </v-expand-transition>

      <!-- ============================================================ -->
      <!-- ค้นหาบุคคลจาก ID                                             -->
      <!-- ============================================================ -->
      <div class="section-card mb-6">
        <div class="section-card__header">
          <v-icon color="#6366F1" class="mr-2">mdi-account-search</v-icon>
          <h2 class="section-title">
            ค้นหาบุคคลจากฐานข้อมูลสถานศึกษาอื่น ๆ ในระบบ
          </h2>
        </div>

        <v-row align="center" class="mt-2">
          <v-col cols="12" md="9">
            <v-text-field
              v-model="searchIDcard"
              append-icon="mdi-magnify"
              label="ค้นหาด้วยรหัสบัตรประชาชน"
              single-line
              hide-details
              dense
              outlined
              rounded
              class="search-input"
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-btn
              block
              depressed
              color="#6366F1"
              dark
              rounded
              @click="personnel_etcSearchSYS()"
            >
              <v-icon left small>mdi-account-search</v-icon> ค้นหา
            </v-btn>
          </v-col>
        </v-row>

        <v-expand-transition>
          <v-alert
            v-if="personnel_etcSYSs.personnel_etc_id_card"
            type="info"
            outlined
            prominent
            border="left"
            class="mt-3 search-result-alert"
          >
            <div class="font-weight-bold">
              {{ personnel_etcSYSs.college_name }}
            </div>
            <div class="mt-1">
              <v-chip small label color="#6366F1" dark class="mr-2">
                {{ personnel_etcSYSs.personnel_etc_id_card }}
              </v-chip>
              {{ personnel_etcSYSs.personnel_etc_title
              }}{{ personnel_etcSYSs.personnel_etc_fristname }}
              {{ personnel_etcSYSs.personnel_etc_lastname }}
            </div>
          </v-alert>
        </v-expand-transition>

        <!-- ตารางรายการขอเพิ่ม/ย้ายบุคคล -->
        <v-row class="mt-4">
          <v-col cols="12" md="6">
            <div class="request-card request-card--add">
              <div class="request-card__header">
                <v-icon small color="#22C55E" class="mr-1"
                  >mdi-account-plus</v-icon
                >
                <span class="font-weight-bold">รายการขอเพิ่มบุคคล</span>
                <v-chip x-small label color="#22C55E" dark class="ml-2">{{
                  personnel_reqReqNTB.length
                }}</v-chip>
              </div>
              <v-data-table
                :headers="personnel_reqHearder"
                :items="personnel_reqReqNTB"
                :items-per-page="5"
                class="modern-table"
                dense
              >
                <template v-slot:item.personel_reqIDcard="{ item }">
                  <span class="font-weight-medium">
                    {{ item.personnel_etc_title
                    }}{{ item.personnel_etc_fristname }}
                    {{ item.personnel_etc_lastname }}
                  </span>
                </template>
                <template v-slot:item.personel_reqStatus="{ item }">
                  <v-chip
                    small
                    label
                    color="#94A3B8"
                    dark
                    v-if="item.personel_reqStatus === 'req'"
                  >
                    <v-icon x-small left>mdi-clock-outline</v-icon>
                    รอตรวจสอบ
                  </v-chip>
                </template>
                <template v-slot:item.personel_reqDate="{ item }">
                  <span class="text-caption">
                    {{
                      item.personel_reqDate
                        | moment("add", "543 years")
                        | moment("D MMM YYYY")
                    }}
                  </span>
                </template>
                <template v-slot:item.action="{ item }">
                  <v-btn
                    x-small
                    rounded
                    color="#EF4444"
                    dark
                    @click="
                      cancelReg(
                        item.personel_reqNewCollege,
                        item.personel_reqIDcard
                      )
                    "
                  >
                    <v-icon x-small left>mdi-close</v-icon> ยกเลิก
                  </v-btn>
                </template>
              </v-data-table>
            </div>
          </v-col>

          <v-col cols="12" md="6">
            <div class="request-card request-card--move">
              <div class="request-card__header">
                <v-icon small color="#F97316" class="mr-1"
                  >mdi-account-switch</v-icon
                >
                <span class="font-weight-bold"
                  >รายการขออนุมัติย้ายข้อมูลบุคคล</span
                >
                <v-chip x-small label color="#F97316" dark class="ml-2">{{
                  personnel_reqReqOTB.length
                }}</v-chip>
              </div>
              <v-data-table
                :headers="personnel_reqOHearder"
                :items="personnel_reqReqOTB"
                :items-per-page="5"
                class="modern-table"
                dense
              >
                <template v-slot:item.personel_reqIDcard="{ item }">
                  <span class="font-weight-medium">
                    {{ item.personnel_etc_title
                    }}{{ item.personnel_etc_fristname }}
                    {{ item.personnel_etc_lastname }}
                  </span>
                </template>
                <template v-slot:item.personel_reqStatus="{ item }">
                  <v-btn
                    x-small
                    rounded
                    color="#22C55E"
                    dark
                    v-if="item.personel_reqStatus === 'req'"
                    @click="personnel_reqApprove(item.personel_reqIDcard)"
                  >
                    <v-icon x-small left>mdi-check</v-icon>
                    อนุมัติย้าย
                  </v-btn>
                </template>
                <template v-slot:item.personel_reqDate="{ item }">
                  <span class="text-caption">
                    {{
                      item.personel_reqDate
                        | moment("add", "543 years")
                        | moment("D MMM YYYY")
                    }}
                  </span>
                </template>
              </v-data-table>
            </div>
          </v-col>
        </v-row>
      </div>

      <!-- ============================================================ -->
      <!-- FILTER & SEARCH BAR (เพิ่มกรอง ภาค / จังหวัด)                -->
      <!-- ============================================================ -->
      <div class="section-card filter-section mb-6">
        <div class="section-card__header">
          <v-icon color="#EF4444" class="mr-2">mdi-filter-variant</v-icon>
          <h2 class="section-title">ค้นหาและกรองข้อมูล</h2>
          <v-spacer />
          <v-chip
            v-if="areaFilterActive"
            small
            label
            color="#6366F1"
            dark
            close
            @click:close="clearAreaFilter()"
          >
            <v-icon x-small left>mdi-map-marker</v-icon>
            {{ areaFilterLabel }}
          </v-chip>
        </div>

        <!-- แถวที่ 1 : ภาค / จังหวัด / วิทยาลัย -->
        <v-row class="mt-2" align="center">
          <v-col cols="12" md="4">
            <v-autocomplete
              outlined
              rounded
              dense
              hide-details
              v-model="selectedRegion"
              label="กรองตามภาค"
              :items="regions"
              item-text="region_name"
              item-value="region_ID"
              clearable
              prepend-inner-icon="mdi-map"
              @change="onRegionChange()"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="4">
            <v-autocomplete
              outlined
              rounded
              dense
              hide-details
              v-model="selectedProvince"
              label="กรองตามจังหวัด"
              :items="provincesByRegion"
              item-text="province_name"
              item-value="province_ID"
              clearable
              prepend-inner-icon="mdi-map-marker"
              @change="personnel_etcSearchByArea()"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="4">
            <v-autocomplete
              outlined
              rounded
              dense
              hide-details
              v-model="collegeSearch"
              label="ค้นหาวิทยาลัย"
              :items="colleges"
              item-text="college_name"
              item-value="college_code"
              @change="personnel_etcSearch()"
              clearable
              prepend-inner-icon="mdi-school"
            ></v-autocomplete>
          </v-col>
        </v-row>

        <!-- แถวที่ 2 : คำค้น / กรองประเภท / กรองช่วยราชการ -->
        <v-row class="mt-1" align="center">
          <v-col cols="12" md="4">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="ค้นหา ระบุคำ หรือ ส่วนข้อความเกี่ยวข้อง"
              single-line
              hide-details
              clearable
              outlined
              rounded
              dense
              class="search-input"
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              v-model="filterType"
              :items="filterTypeOptions"
              item-text="text"
              item-value="value"
              label="กรองตามประเภท"
              clearable
              outlined
              rounded
              dense
              hide-details
              prepend-inner-icon="mdi-badge-account"
            ></v-select>
          </v-col>
          <v-col cols="12" md="2">
            <v-select
              v-model="filterHelpStatus"
              :items="filterHelpOptions"
              item-text="text"
              item-value="value"
              label="ช่วยราชการ"
              clearable
              outlined
              rounded
              dense
              hide-details
              prepend-inner-icon="mdi-swap-horizontal"
            ></v-select>
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              v-model="selectedHeaders"
              :items="headers"
              label="เลือกคอลัมน์ที่ต้องการแสดง"
              multiple
              outlined
              rounded
              dense
              hide-details
              return-object
              prepend-inner-icon="mdi-view-column"
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 2" x-small label class="mr-1">
                  <span>{{ item.text }}</span>
                </v-chip>
                <span v-if="index === 2" class="grey--text text-caption">
                  (+{{ selectedHeaders.length - 2 }})
                </span>
              </template>
            </v-select>
          </v-col>
        </v-row>
      </div>

      <!-- ============================================================ -->
      <!-- MAIN DATA TABLE                                               -->
      <!-- ============================================================ -->
      <div class="section-card">
        <div class="section-card__header">
          <v-icon color="#3B82F6" class="mr-2">mdi-table-large</v-icon>
          <h2 class="section-title">ตารางข้อมูลบุคลากร</h2>
          <v-spacer />
          <v-btn
            small
            text
            color="#14B8A6"
            class="mr-2"
            :disabled="filteredPersonnel.length === 0"
            @click="exportCurrentView()"
          >
            <v-icon small left>mdi-file-excel</v-icon>
            ส่งออกตารางนี้
          </v-btn>
          <v-chip small label outlined color="#64748B">
            {{ filteredPersonnel.length }} รายการ
          </v-chip>
        </div>

        <v-data-table
          :loading="loading"
          :headers="showHeaders"
          :items="filteredPersonnel"
          :search="search"
          :item-class="row_classes"
          disable-pagination
          class="modern-table main-table mt-3"
          dense
        >
          <!-- Login -->
          <template v-slot:item.login="{ item }">
            <v-btn
              v-if="isLoginAllowed(item.personnel_etc_m_type)"
              @click="
                userLogin(item.personnel_etc_id_card, item.personnel_etc_pass)
              "
              icon
              small
              color="#6366F1"
            >
              <v-icon small>mdi-login-variant</v-icon>
            </v-btn>
          </template>

          <!-- ภาค -->
          <template v-slot:item.region_name="{ item }">
            <span class="text-caption">{{ item.region_name || "-" }}</span>
          </template>

          <!-- จังหวัด -->
          <template v-slot:item.province_name="{ item }">
            <span class="text-caption">{{ item.province_name || "-" }}</span>
          </template>

          <!-- วิทยาลัย -->
          <template v-slot:item.college_name="{ item }">
            <span class="text-caption">{{
              item.college_name || item.personnel_etc_college_code || "-"
            }}</span>
          </template>

          <!-- ประเภท (chip + icon ตามแนวทาง college) -->
          <template v-slot:item.personnel_etc_m_type="{ item }">
            <v-chip
              small
              label
              :color="getPersonnelChipColor(item.personnel_etc_m_type)"
              :dark="!!item.personnel_etc_m_type"
              :outlined="!item.personnel_etc_m_type"
              class="font-weight-medium"
              style="min-width:120px; justify-content:center"
            >
              <v-icon left x-small v-if="item.personnel_etc_m_type">{{
                getPersonnelTypeIcon(item.personnel_etc_m_type)
              }}</v-icon>
              {{ getPersonnelTypeLabel(item.personnel_etc_m_type) }}
            </v-chip>
          </template>

          <!-- ภารกิจ/งาน (รองรับหลายงาน JSON) -->
          <template v-slot:item.personnel_etc_workgroup="{ item }">
            <div v-if="item.personnel_etc_workgroup">
              <v-chip
                v-for="wg in parseWorkgroups(item.personnel_etc_workgroup)"
                :key="wg"
                x-small
                label
                class="mr-1 mb-1"
                color="#E2E8F0"
                >{{ getWorkgroupName(wg) }}</v-chip
              >
            </div>
            <span v-else class="text--disabled">-</span>
          </template>

          <!-- เงินเดือน -->
          <template v-slot:item.personnel_etc_salary="{ item }">
            <span class="font-weight-medium" v-if="item.personnel_etc_salary">
              {{ Number(item.personnel_etc_salary).toLocaleString() }}
              <span class="caption grey--text">฿</span>
            </span>
            <span v-else class="text--disabled">-</span>
          </template>

          <!-- งบประมาณ -->
          <template v-slot:item.personnel_etc_budget="{ item }">
            <v-chip
              v-if="item.personnel_etc_budget"
              x-small
              label
              :color="
                item.personnel_etc_budget === 'budget' ? '#3B82F6' : '#8B5CF6'
              "
              dark
            >
              {{ getBudgetLabel(item.personnel_etc_budget) }}
            </v-chip>
          </template>

          <!-- ชั่วโมงสอน ภ.1 -->
          <template v-slot:item.personnel_etc_teach_hours_s1="{ item }">
            <div v-if="isTeachingType(item.personnel_etc_m_type)">
              <v-chip
                x-small
                v-if="item.personnel_etc_teach_hours_s1"
                :color="
                  parseInt(item.personnel_etc_teach_hours_s1) >= 18
                    ? 'success'
                    : 'warning'
                "
                dark
                >{{ item.personnel_etc_teach_hours_s1 }} ชม.</v-chip
              >
              <span v-else class="grey--text">-</span>
            </div>
            <span v-else class="text--disabled">-</span>
          </template>

          <!-- ชั่วโมงสอน ภ.2 -->
          <template v-slot:item.personnel_etc_teach_hours_s2="{ item }">
            <div v-if="isTeachingType(item.personnel_etc_m_type)">
              <v-chip
                x-small
                v-if="item.personnel_etc_teach_hours_s2"
                :color="
                  parseInt(item.personnel_etc_teach_hours_s2) >= 18
                    ? 'success'
                    : 'warning'
                "
                dark
                >{{ item.personnel_etc_teach_hours_s2 }} ชม.</v-chip
              >
              <span v-else class="grey--text">-</span>
            </div>
            <span v-else class="text--disabled">-</span>
          </template>

          <!-- ประเภทวิชา -->
          <template v-slot:item.personnel_etc_subject="{ item }">
            <div
              v-if="isTeachingType(item.personnel_etc_m_type)"
              class="text-center"
            >
              <v-chip
                v-if="item.personnel_etc_subject"
                small
                label
                color="#6366F1"
                dark
              >
                {{ getSubjectLabel(item.personnel_etc_subject) }}
              </v-chip>
              <v-chip v-else small label color="#F59E0B" dark>
                <v-icon x-small left>mdi-alert</v-icon>
                กรุณาเลือก
              </v-chip>
            </div>
          </template>

          <!-- ปีหลักสูตร (เตือนถ้าต่ำกว่า 2567) -->
          <template v-slot:item.year_course="{ item }">
            <div v-if="isTeachingType(item.personnel_etc_m_type)">
              <v-chip
                small
                label
                v-if="item.personnel_etc_subject === '66'"
                color="#94A3B8"
                dark
                >ระยะสั้น</v-chip
              >
              <v-chip
                small
                label
                v-else-if="
                  item.year_course && parseInt(item.year_course) >= 2567
                "
                color="success"
                dark
              >
                {{ item.year_course }}
              </v-chip>
              <v-tooltip bottom v-else>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip small label color="red" dark v-bind="attrs" v-on="on">
                    <v-icon x-small left>mdi-alert</v-icon>
                    {{ item.year_course || "ไม่ระบุ" }}
                  </v-chip>
                </template>
                <span
                  >ปีหลักสูตรต่ำกว่า 2567
                  กรุณาปรับปรุงสาขาวิชาให้เป็นหลักสูตรปัจจุบัน</span
                >
              </v-tooltip>
            </div>
            <span v-else class="text--disabled">-</span>
          </template>

          <!-- สถานะช่วยราชการ -->
          <template v-slot:item.personnel_etc_help_status="{ item }">
            <v-chip
              v-if="item.personnel_etc_help_status === 'helping'"
              small
              label
              color="#F97316"
              dark
            >
              <v-icon x-small left>mdi-arrow-right-bold</v-icon>
              ไปช่วยราชการ
            </v-chip>
            <v-chip
              v-else-if="item.personnel_etc_help_status === 'receiving'"
              small
              label
              color="#14B8A6"
              dark
            >
              <v-icon x-small left>mdi-arrow-left-bold</v-icon>
              รับช่วยราชการ
            </v-chip>
            <span v-else class="text--disabled">-</span>
          </template>

          <!-- วิทยาลัยที่ช่วย -->
          <template v-slot:item.personnel_etc_help_college_code="{ item }">
            <span class="text-caption">
              {{
                item.collegeHelpname ||
                  item.help_college_name ||
                  item.personnel_etc_help_college_code ||
                  "-"
              }}
            </span>
          </template>

          <!-- แก้ไข -->
          <template v-slot:item.actions="{ item }">
            <v-btn
              icon
              small
              color="#F59E0B"
              @click="personnel_etcEdit(item.personnel_etcIDNO)"
            >
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
          </template>

          <!-- ลบ -->
          <template v-slot:item.action_s="{ item }">
            <v-btn
              icon
              small
              color="#EF4444"
              @click="personnel_etcDelete(item.personnel_etcIDNO)"
            >
              <v-icon small>mdi-delete-outline</v-icon>
            </v-btn>
          </template>

          <v-alert
            slot="no-results"
            :value="true"
            color="error"
            icon="mdi-alert"
            class="ma-3"
          >
            ไม่พบผลลัพธ์ "{{ search }}"
          </v-alert>
        </v-data-table>
      </div>

      <!-- ============================================================ -->
      <!-- Dialog: ลบข้อมูล                                              -->
      <!-- ============================================================ -->
      <v-dialog v-model="deletepersonnel_etcdialog" persistent max-width="480">
        <v-card class="dialog-card">
          <div class="dialog-card__header dialog-card__header--danger">
            <v-icon size="32" color="white">mdi-delete-alert</v-icon>
            <h3>ยืนยันการลบข้อมูล</h3>
          </div>
          <v-card-text class="pt-6 pb-2">
            <v-form ref="deletepersonnel_etcform" lazy-validation>
              <div class="delete-info-card">
                <div class="delete-info-card__id">
                  <v-icon small color="#EF4444" class="mr-1"
                    >mdi-card-account-details</v-icon
                  >
                  {{ editpersonnel_etc.personnel_etc_id_card }}
                </div>
                <div class="delete-info-card__name">
                  {{ editpersonnel_etc.personnel_etc_title
                  }}{{ editpersonnel_etc.personnel_etc_fristname }}
                  {{ editpersonnel_etc.personnel_etc_lastname }}
                </div>
              </div>
            </v-form>
          </v-card-text>
          <v-card-actions class="pa-4 pt-0">
            <v-spacer />
            <v-btn
              rounded
              outlined
              @click.stop="deletepersonnel_etcdialog = false"
            >
              <v-icon left small>mdi-close</v-icon> ยกเลิก
            </v-btn>
            <v-btn
              rounded
              color="#EF4444"
              dark
              depressed
              @click.stop="deletepersonnel_etcubmit()"
            >
              <v-icon left small>mdi-delete</v-icon> ลบข้อมูล
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- ============================================================ -->
      <!-- Dialog: แก้ไขข้อมูลบุคลากร                                    -->
      <!-- ============================================================ -->
      <v-dialog
        v-model="editpersonnel_etcdialog"
        persistent
        max-width="960"
        scrollable
      >
        <v-card class="dialog-card">
          <div class="dialog-card__header dialog-card__header--edit">
            <v-icon size="32" color="white">mdi-account-edit</v-icon>
            <h3>แก้ไขข้อมูลบุคลากร</h3>
          </div>
          <v-card-text class="pt-5 pb-2" style="max-height: 70vh;">
            <v-form ref="editpersonnel_etcform" lazy-validation>
              <!-- ประเภทบุคลากร -->
              <div class="edit-section">
                <div class="edit-section__title">
                  <v-icon small color="#6366F1" class="mr-1"
                    >mdi-badge-account</v-icon
                  >
                  ประเภทบุคลากร
                </div>
                <v-select
                  v-if="isGovType(editpersonnel_etc.personnel_etc_m_type)"
                  outlined
                  dense
                  rounded
                  v-model="editpersonnel_etc.personnel_etc_m_type"
                  :items="type_personnelGov"
                  item-text="text"
                  item-value="value"
                  label="ประเภทบุคลากร"
                  :rules="[v => !!v || '']"
                ></v-select>
                <v-select
                  v-else
                  outlined
                  dense
                  rounded
                  v-model="editpersonnel_etc.personnel_etc_m_type"
                  :items="type_personnel"
                  item-text="text"
                  item-value="value"
                  label="ประเภทบุคลากร"
                  :rules="[v => !!v || '']"
                ></v-select>
              </div>

              <v-divider class="my-3" />

              <v-row>
                <!-- คอลัมน์ 1: ข้อมูลพื้นฐาน -->
                <v-col cols="12" md="4">
                  <div class="edit-section">
                    <div class="edit-section__title">
                      <v-icon small color="#3B82F6" class="mr-1"
                        >mdi-account</v-icon
                      >
                      ข้อมูลพื้นฐาน
                    </div>
                    <v-text-field
                      outlined
                      dense
                      rounded
                      v-model="editpersonnel_etc.personnel_etc_id_card"
                      label="รหัสบัตรประชาชน"
                      :rules="[v => !!v || 'required']"
                      prepend-inner-icon="mdi-card-account-details-outline"
                    ></v-text-field>
                    <v-text-field
                      outlined
                      dense
                      rounded
                      v-model="editpersonnel_etc.personnel_etc_title"
                      label="คำนำหน้าชื่อ"
                      :rules="[v => !!v || '']"
                    ></v-text-field>
                    <v-text-field
                      outlined
                      dense
                      rounded
                      v-model="editpersonnel_etc.personnel_etc_fristname"
                      label="ชื่อ"
                      :rules="[v => !!v || '']"
                    ></v-text-field>
                    <v-text-field
                      outlined
                      dense
                      rounded
                      v-model="editpersonnel_etc.personnel_etc_lastname"
                      label="นามสกุล"
                      :rules="[v => !!v || '']"
                    ></v-text-field>
                  </div>
                </v-col>

                <!-- คอลัมน์ 2: ข้อมูลการทำงาน -->
                <v-col cols="12" md="4">
                  <div class="edit-section">
                    <div class="edit-section__title">
                      <v-icon small color="#22C55E" class="mr-1"
                        >mdi-briefcase</v-icon
                      >
                      ข้อมูลการทำงาน
                    </div>
                    <v-autocomplete
                      v-if="
                        showWorkgroup(editpersonnel_etc.personnel_etc_m_type)
                      "
                      :items="workgroups"
                      item-text="workGroupName"
                      item-value="workGroupID"
                      outlined
                      dense
                      rounded
                      multiple
                      chips
                      small-chips
                      deletable-chips
                      v-model="editpersonnel_etc.personnel_etc_workgroup"
                      label="ภารกิจ/งาน"
                    ></v-autocomplete>
                    <v-text-field
                      v-if="
                        showIdPosition(editpersonnel_etc.personnel_etc_m_type)
                      "
                      outlined
                      dense
                      rounded
                      v-model="editpersonnel_etc.personnel_etc_id_position"
                      label="เลขที่ตำแหน่ง"
                    ></v-text-field>
                    <v-text-field
                      v-if="
                        showRankLevel(editpersonnel_etc.personnel_etc_m_type)
                      "
                      outlined
                      dense
                      rounded
                      v-model="editpersonnel_etc.personnel_etc_level"
                      label="อันดับ/ระดับ"
                    ></v-text-field>
                    <v-text-field
                      v-if="
                        showRankLevel(editpersonnel_etc.personnel_etc_m_type)
                      "
                      outlined
                      dense
                      rounded
                      v-model="editpersonnel_etc.personnel_etc_rang"
                      label="วิทยฐานะ"
                    ></v-text-field>
                    <v-select
                      v-if="isTemporary(editpersonnel_etc.personnel_etc_m_type)"
                      outlined
                      dense
                      rounded
                      v-model="editpersonnel_etc.personnel_etc_budget"
                      label="งบประมาณ"
                      :items="budget_type"
                      item-text="text"
                      item-value="value"
                    ></v-select>
                    <v-text-field
                      outlined
                      dense
                      rounded
                      v-model="editpersonnel_etc.personnel_etc_salary"
                      label="อัตราเงินเดือน"
                      type="number"
                      prepend-inner-icon="mdi-currency-thb"
                    ></v-text-field>

                    <!-- ประเภทวิชา/สาขา -->
                    <v-autocomplete
                      v-if="
                        isTeachingTypeOrGovSP(
                          editpersonnel_etc.personnel_etc_m_type
                        )
                      "
                      outlined
                      dense
                      rounded
                      v-model="editpersonnel_etc.personnel_etc_subject"
                      :items="subject_types"
                      item-text="subject_typeName"
                      item-value="subject_typeID"
                      label="ประเภทวิชา"
                      @change="onSubjectChangeEdit()"
                    >
                      <template v-slot:item="{ item }">
                        <div>
                          <span class="font-weight-bold"
                            >{{ item.subject_typeID }} :</span
                          >
                          {{ item.subject_typeName }}
                        </div>
                      </template>
                    </v-autocomplete>
                    <v-autocomplete
                      v-if="
                        isTeachingTypeOrGovSP(
                          editpersonnel_etc.personnel_etc_m_type
                        )
                      "
                      outlined
                      dense
                      rounded
                      v-model="editpersonnel_etc.personnel_etc_branch"
                      :items="rate_work_course_stds"
                      :item-text="
                        editpersonnel_etc.personnel_etc_subject === '66'
                          ? 'short_courseSTBranch'
                          : 'branch_name_th'
                      "
                      :item-value="
                        editpersonnel_etc.personnel_etc_subject === '66'
                          ? 'short_courseSTBranchID'
                          : 'id_course_branch'
                      "
                      label="สาขาวิชา"
                      @change="onBranchChangeEdit()"
                    >
                      <template v-slot:item="{ item }">
                        <div class="font-weight-bold">
                          <span
                            v-if="
                              editpersonnel_etc.personnel_etc_subject === '66'
                            "
                          >
                            {{ item.short_courseSTBranchID }} :
                            {{ item.short_courseSTBranch }}
                          </span>
                          <span v-else>
                            {{ item.year_course }} :
                            {{ item.branch_name_th }}
                          </span>
                        </div>
                      </template>
                    </v-autocomplete>
                    <v-autocomplete
                      v-if="
                        isTeachingTypeOrGovSP(
                          editpersonnel_etc.personnel_etc_m_type
                        )
                      "
                      outlined
                      dense
                      rounded
                      v-model="editpersonnel_etc.personnel_etc_branch_sub"
                      :items="rate_work_course_stdSubs"
                      :item-text="
                        editpersonnel_etc.personnel_etc_subject === '66'
                          ? 'short_courseName'
                          : 'branch_sub_name_th'
                      "
                      :item-value="
                        editpersonnel_etc.personnel_etc_subject === '66'
                          ? 'short_courseID'
                          : 'id_course_branch_sub'
                      "
                      label="สาขางาน"
                    ></v-autocomplete>
                  </div>
                </v-col>

                <!-- คอลัมน์ 3: การศึกษา + ช่วยราชการ -->
                <v-col cols="12" md="4">
                  <div class="edit-section">
                    <div class="edit-section__title">
                      <v-icon small color="#F59E0B" class="mr-1"
                        >mdi-school</v-icon
                      >
                      วุฒิการศึกษา
                    </div>
                    <v-text-field
                      outlined
                      dense
                      rounded
                      v-model="editpersonnel_etc.personnel_etc_education_1"
                      label="ต่ำกว่า ป.ตรี"
                    ></v-text-field>
                    <v-text-field
                      outlined
                      dense
                      rounded
                      v-model="editpersonnel_etc.personnel_etc_education_2"
                      label="ปริญญาตรี"
                    ></v-text-field>
                    <v-text-field
                      outlined
                      dense
                      rounded
                      v-model="editpersonnel_etc.personnel_etc_education_3"
                      label="ปริญญาโท"
                    ></v-text-field>
                    <v-text-field
                      outlined
                      dense
                      rounded
                      v-model="editpersonnel_etc.personnel_etc_education_4"
                      label="ปริญญาเอก"
                    ></v-text-field>
                  </div>

                  <div class="edit-section mt-4">
                    <div class="edit-section__title">
                      <v-icon small color="#F97316" class="mr-1"
                        >mdi-swap-horizontal-bold</v-icon
                      >
                      ข้อมูลช่วยราชการ
                    </div>
                    <v-select
                      outlined
                      dense
                      rounded
                      v-model="editpersonnel_etc.personnel_etc_help_status"
                      :items="helpStatusOptions"
                      item-text="text"
                      item-value="value"
                      label="สถานะช่วยราชการ"
                      clearable
                    ></v-select>
                    <v-autocomplete
                      outlined
                      dense
                      rounded
                      v-model="
                        editpersonnel_etc.personnel_etc_help_college_code
                      "
                      :items="colleges"
                      item-text="college_name"
                      item-value="college_code"
                      label="วิทยาลัยที่ช่วยราชการ"
                      clearable
                      :disabled="!editpersonnel_etc.personnel_etc_help_status"
                    ></v-autocomplete>
                    <v-menu
                      v-model="menuHelpDate"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          outlined
                          dense
                          rounded
                          v-model="editpersonnel_etc.personnel_etc_help_date"
                          label="วันที่เริ่มช่วยราชการ"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          clearable
                          :disabled="
                            !editpersonnel_etc.personnel_etc_help_status
                          "
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="editpersonnel_etc.personnel_etc_help_date"
                        @input="menuHelpDate = false"
                        locale="th"
                      ></v-date-picker>
                    </v-menu>
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-divider />
          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn
              rounded
              outlined
              @click.stop="editpersonnel_etcdialog = false"
            >
              <v-icon left small>mdi-close</v-icon> ยกเลิก
            </v-btn>
            <v-btn
              rounded
              color="#F59E0B"
              dark
              depressed
              @click.stop="editpersonnel_etcSubmit()"
            >
              <v-icon left small>mdi-pencil</v-icon> แก้ไขข้อมูล
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- ============================================================ -->
      <!-- Dialog: ส่งออก Excel แยกกลุ่ม                                 -->
      <!-- ============================================================ -->
      <v-dialog v-model="showExportDialog" max-width="600" scrollable>
        <v-card class="dialog-card">
          <div
            class="dialog-card__header"
            style="background: linear-gradient(135deg, #14B8A6, #0D9488);"
          >
            <v-icon size="32" color="white">mdi-file-excel</v-icon>
            <h3>ส่งออกข้อมูล Excel แยกตามประเภท</h3>
          </div>
          <v-card-text class="pt-5 pb-2">
            <p class="text-body-2 mb-4">
              ข้อมูลบุคลากรทั้งหมดมีจำนวนมาก (~40,000 รายการ)
              กรุณาเลือกประเภทที่ต้องการส่งออก
              <span
                v-if="areaFilterActive"
                class="primary--text font-weight-bold"
              >
                (กรองเฉพาะ {{ areaFilterLabel }})
              </span>
            </p>

            <v-list dense>
              <v-list-item
                v-for="(expType, idx) in exportTypes"
                :key="'exp-' + idx"
                @click="exportExcelByType(expType.value)"
                :disabled="exportingType === expType.value"
                class="export-list-item mb-1"
              >
                <v-list-item-avatar size="36">
                  <v-icon :color="expType.color" size="20">{{
                    expType.icon
                  }}</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold">
                    {{ expType.label }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ getCountForType(expType.value) }} รายการ
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-progress-circular
                    v-if="exportingType === expType.value"
                    indeterminate
                    size="24"
                    width="2"
                    :color="expType.color"
                  />
                  <v-icon v-else color="#64748B">mdi-download</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>

            <v-divider class="my-3" />

            <v-btn
              block
              depressed
              color="#14B8A6"
              dark
              rounded
              :loading="exportingType === 'all'"
              @click="exportExcelAll()"
            >
              <v-icon left>mdi-download-multiple</v-icon>
              ส่งออกทั้งหมด (แยก Sheet ตามประเภท)
            </v-btn>

            <v-expand-transition>
              <div v-if="exportProgress.show" class="mt-3">
                <div class="text-caption mb-1">
                  {{ exportProgress.text }}
                </div>
                <v-progress-linear
                  :value="exportProgress.percent"
                  color="#14B8A6"
                  rounded
                  height="8"
                />
              </div>
            </v-expand-transition>
          </v-card-text>
          <v-card-actions class="pa-4 pt-0">
            <v-spacer />
            <v-btn rounded outlined @click="showExportDialog = false">
              <v-icon left small>mdi-close</v-icon> ปิด
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Video Dialog -->
      <v-dialog
        v-model="VideoDialogYoutubeConditionbranch"
        persistent
        max-width="80%"
      >
        <v-card class="pa-0" style="border-radius: 16px; overflow: hidden;">
          <iframe
            width="100%"
            height="600px"
            src="https://www.youtube.com/embed/AGr0Gx0hxME"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
          <v-card-actions class="pa-3">
            <v-spacer />
            <v-btn
              rounded
              outlined
              @click.stop="VideoDialogYoutubeConditionbranch = false"
            >
              <v-icon left small>mdi-close</v-icon> ปิด
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>

    <!-- Snackbar -->
    <v-snackbar
      v-model="snackbar.show"
      top
      right
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      rounded="lg"
    >
      <v-icon left>{{ snackbar.icon }}</v-icon>
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">
          ปิด
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Manpower_bar from "../../components/admin/manpower_bar.vue";

export default {
  name: "personnel_etc_admin",
  components: { Manpower_bar },

  data() {
    return {
      ApiKey: "HRvec2021",
      loading: false,
      search: "",
      searchIDcard: "",
      editpersonnel_etcdialog: false,
      deletepersonnel_etcdialog: false,
      VideoDialogYoutubeConditionbranch: false,
      menuHelpDate: false,
      snackbar: { show: false, color: "", timeout: 5000, icon: "", text: "" },

      // ===== ตัวกรอง ภาค / จังหวัด (ใหม่) =====
      regions: [],
      provinces: [],
      selectedRegion: null,
      selectedProvince: null,

      // ===== ตัวกรองประเภท / ช่วยราชการ (จาก college) =====
      filterType: null,
      filterHelpStatus: null,
      filterTypeOptions: [
        { text: "ข้าราชการครู", value: "teacher" },
        { text: "รองผู้อำนวยการ", value: "se_director" },
        { text: "ผู้อำนวยการ", value: "director" },
        { text: "38 ค.(2)", value: "38" },
        { text: "ลูกจ้างประจำ", value: "permanent" },
        { text: "พนักงานราชการ(สายการสอน)", value: "governmentteach" },
        { text: "พนักงานราชการ(สายสนับสนุน)", value: "governmentsp" },
        { text: "ครูอัตราจ้าง", value: "temporary" },
        { text: "ลูกจ้างชั่วคราว", value: "temporary_job" }
      ],
      filterHelpOptions: [
        { text: "ไปช่วยราชการ", value: "helping" },
        { text: "รับช่วยราชการ", value: "receiving" },
        { text: "ปกติ (ไม่ช่วยราชการ)", value: "normal" }
      ],

      headers: [],
      selectedHeaders: [],
      headersMap: [
        { text: "Login", align: "center", value: "login", width: "60px" },
        {
          text: "ประเภท",
          align: "center",
          value: "personnel_etc_m_type",
          width: "180px"
        },
        { text: "แก้ไข", align: "center", value: "actions", width: "60px" },
        { text: "ลบ", align: "center", value: "action_s", width: "60px" },
        // ===== คอลัมน์ ภาค / จังหวัด / วิทยาลัย (ใหม่) =====
        { text: "ภาค", align: "left", value: "region_name", width: "120px" },
        {
          text: "จังหวัด",
          align: "left",
          value: "province_name",
          width: "120px"
        },
        {
          text: "วิทยาลัย",
          align: "left",
          value: "college_name",
          width: "200px"
        },
        {
          text: "รหัสบัตรประชาชน",
          align: "center",
          value: "personnel_etc_id_card",
          width: "150px"
        },
        {
          text: "คำนำหน้า",
          align: "center",
          value: "personnel_etc_title",
          width: "90px"
        },
        {
          text: "ชื่อ",
          align: "left",
          value: "personnel_etc_fristname",
          width: "120px"
        },
        {
          text: "นามสกุล",
          align: "left",
          value: "personnel_etc_lastname",
          width: "120px"
        },
        {
          text: "ภารกิจ/งาน",
          align: "left",
          value: "personnel_etc_workgroup",
          width: "180px"
        },
        {
          text: "เลขที่ตำแหน่ง",
          align: "center",
          value: "personnel_etc_id_position",
          width: "120px"
        },
        {
          text: "อันดับ/ระดับ",
          align: "center",
          value: "personnel_etc_level",
          width: "110px"
        },
        {
          text: "วิทยฐานะ",
          align: "center",
          value: "personnel_etc_rang",
          width: "110px"
        },
        {
          text: "ประเภท",
          align: "center",
          value: "personnel_etc_type",
          width: "100px"
        },
        {
          text: "ด้าน",
          align: "center",
          value: "personnel_etc_about",
          width: "100px"
        },
        {
          text: "งบประมาณ",
          align: "center",
          value: "personnel_etc_budget",
          width: "160px"
        },
        {
          text: "เงินเดือน",
          align: "right",
          value: "personnel_etc_salary",
          width: "110px"
        },
        {
          text: "ชม.สอน ภ.1",
          align: "center",
          value: "personnel_etc_teach_hours_s1",
          width: "100px"
        },
        {
          text: "ชม.สอน ภ.2",
          align: "center",
          value: "personnel_etc_teach_hours_s2",
          width: "100px"
        },
        {
          text: "ต่ำกว่า ป.ตรี",
          align: "left",
          value: "personnel_etc_education_1",
          width: "120px"
        },
        {
          text: "ปริญญาตรี",
          align: "left",
          value: "personnel_etc_education_2",
          width: "120px"
        },
        {
          text: "ปริญญาโท",
          align: "left",
          value: "personnel_etc_education_3",
          width: "120px"
        },
        {
          text: "ปริญญาเอก",
          align: "left",
          value: "personnel_etc_education_4",
          width: "120px"
        },
        {
          text: "ประเภทวิชา",
          align: "center",
          value: "personnel_etc_subject",
          width: "160px"
        },
        {
          text: "ปีหลักสูตร",
          align: "center",
          value: "year_course",
          width: "110px"
        },
        {
          text: "สาขาวิชา",
          align: "left",
          value: "personnel_etc_branch_n",
          width: "150px"
        },
        {
          text: "สาขางาน",
          align: "left",
          value: "personnel_etc_branch_Subn",
          width: "150px"
        },
        {
          text: "สถานะช่วยราชการ",
          align: "center",
          value: "personnel_etc_help_status",
          width: "140px"
        },
        {
          text: "วิทยาลัยที่ช่วย",
          align: "center",
          value: "personnel_etc_help_college_code",
          width: "180px"
        }
      ],

      personnel_etcs: [],
      addpersonnel_etc: {},
      editpersonnel_etc: [],
      personnel_etcsCounts: [],
      personnel_etcSYSs: [],
      personnel_reqReqNTB: [],
      personnel_reqReqOTB: [],
      user: [],
      colleges: [],
      collegeSearch: "",
      workgroups: [],
      subject_types: [],
      rate_work_course_stds: [],
      rate_work_course_stdSubs: [],
      personnel_etc_updates: {},

      // ตาราง request
      personnel_reqHearder: [
        { text: "ชื่อ-นามสกุล", align: "left", value: "personel_reqIDcard" },
        { text: "สังกัดเดิม", align: "left", value: "oldCollege" },
        { text: "วันที่", align: "center", value: "personel_reqDate" },
        { text: "สถานะ", align: "center", value: "personel_reqStatus" },
        { text: "", align: "center", value: "action", sortable: false }
      ],
      personnel_reqOHearder: [
        { text: "ชื่อ-นามสกุล", align: "left", value: "personel_reqIDcard" },
        { text: "สังกัดใหม่", align: "left", value: "newCollege" },
        { text: "วันที่", align: "center", value: "personel_reqDate" },
        { text: "สถานะ", align: "center", value: "personel_reqStatus" }
      ],

      // ช่วยราชการ
      helpHeaders: [
        { text: "วิทยาลัยต้นสังกัด", value: "college_name" },
        { text: "รหัสบัตร", value: "personnel_etc_id_card" },
        { text: "ชื่อ", value: "personnel_etc_fristname" },
        { text: "นามสกุล", value: "personnel_etc_lastname" },
        { text: "สถานะ", value: "personnel_etc_help_status" },
        { text: "วิทยาลัยที่ช่วย", value: "collegeHelpname" },
        { text: "วันที่เริ่ม", value: "personnel_etc_help_date" }
      ],
      helpStatusOptions: [
        { text: "ไปช่วยราชการ", value: "helping" },
        { text: "รับช่วยราชการ", value: "receiving" }
      ],

      // ข้อมูลคงที่
      type_personnelGov: [
        { text: "ครู", value: "teacher" },
        { text: "รองผู้อำนวยการ", value: "se_director" },
        { text: "ผู้อำนวยการ", value: "director" },
        { text: "38 ค.(2)", value: "38" },
        { text: "พนักงานราชการ(สายการสอน)", value: "governmentteach" },
        { text: "พนักงานราชการ(สายสนับสนุน)", value: "governmentsp" }
      ],
      type_personnel: [
        { text: "ลูกจ้างประจำ", value: "permanent" },
        { text: "พนักงานราชการ(สายการสอน)", value: "governmentteach" },
        { text: "พนักงานราชการ(สายสนับสนุน)", value: "governmentsp" },
        { text: "ครูอัตราจ้าง", value: "temporary" },
        { text: "ลูกจ้างชั่วคราว", value: "temporary_job" }
      ],
      budget_type: [
        { text: "จากงบประมาณ", value: "budget" },
        { text: "จากรายได้สถานศึกษา", value: "income" }
      ],
      personnelTypeMap: {
        permanent: {
          label: "ลูกจ้างประจำ",
          css: "warning--text",
          color: "#F59E0B"
        },
        governmentteach: {
          label: "พนง.ราชการ(สอน)",
          css: "warning--text",
          color: "#22C55E"
        },
        governmentsp: {
          label: "พนง.ราชการ(สนับสนุน)",
          css: "warning--text",
          color: "#14B8A6"
        },
        temporary: {
          label: "ครูอัตราจ้าง",
          css: "purple--text",
          color: "#8B5CF6"
        },
        temporary_job: {
          label: "ลูกจ้างชั่วคราว",
          css: "purple--text",
          color: "#A855F7"
        },
        teacher: {
          label: "ข้าราชการครู",
          css: "primary--text",
          color: "#3B82F6"
        },
        se_director: {
          label: "รองผู้อำนวยการ",
          css: "info--text",
          color: "#06B6D4"
        },
        director: {
          label: "ผู้อำนวยการ",
          css: "info--text",
          color: "#0EA5E9"
        },
        "38": { label: "38 ค. (2)", css: "primary--text", color: "#6366F1" }
      },
      personnelTypeIconMap: {
        teacher: "mdi-school",
        se_director: "mdi-account-tie",
        director: "mdi-shield-account",
        "38": "mdi-account-cog",
        permanent: "mdi-account-hard-hat",
        governmentteach: "mdi-teach",
        governmentsp: "mdi-account-wrench",
        temporary: "mdi-account-clock",
        temporary_job: "mdi-account-alert"
      },
      subjectMap: {
        "1": "อุตสาหกรรม",
        "2": "พาณิชยกรรม/บริหารธุรกิจ",
        "3": "ศิลปกรรม",
        "4": "คหกรรม",
        "5": "เกษตรกรรม",
        "6": "ประมง",
        "7": "อุตสาหกรรมท่องเที่ยว",
        "8": "อุตสาหกรรมสิ่งทอ",
        "9": "เทคโนโลยีสารสนเทศและการสื่อสาร",
        "10": "อุตสาหกรรมบันเทิงและดนตรี",
        "11": "พาณิชยนาวี",
        "12": "เทคโนโลยีและนวัตกรรมเกษตรอุตสาหกรรม",
        "00": "กลุ่มทักษะชีวิต",
        "66": "ระยะสั้น"
      },

      // ===== Export =====
      showExportDialog: false,
      exportingType: null,
      exportProgress: { show: false, text: "", percent: 0 },
      exportTypes: [
        {
          label: "ข้าราชการครู",
          value: "teacher",
          icon: "mdi-human-male-board",
          color: "#3B82F6"
        },
        {
          label: "ผู้อำนวยการ",
          value: "director",
          icon: "mdi-account-star",
          color: "#0EA5E9"
        },
        {
          label: "รองผู้อำนวยการ",
          value: "se_director",
          icon: "mdi-account-tie",
          color: "#06B6D4"
        },
        {
          label: "38 ค.(2)",
          value: "38",
          icon: "mdi-account-cog",
          color: "#6366F1"
        },
        {
          label: "ลูกจ้างประจำ",
          value: "permanent",
          icon: "mdi-account-check",
          color: "#F59E0B"
        },
        {
          label: "พนง.ราชการ(สอน)",
          value: "governmentteach",
          icon: "mdi-teach",
          color: "#22C55E"
        },
        {
          label: "พนง.ราชการ(สนับสนุน)",
          value: "governmentsp",
          icon: "mdi-account-wrench",
          color: "#14B8A6"
        },
        {
          label: "ครูอัตราจ้าง",
          value: "temporary",
          icon: "mdi-account-clock",
          color: "#8B5CF6"
        },
        {
          label: "ลูกจ้างชั่วคราว",
          value: "temporary_job",
          icon: "mdi-account-alert",
          color: "#A855F7"
        }
      ],

      // Chart: สายการสอน
      courseChartLoading: false,
      courseChartSeries: [],
      courseChartOptions: {
        chart: {
          type: "bar",
          stacked: true,
          toolbar: { show: true, tools: { download: true } },
          fontFamily: "Sarabun, Noto Sans Thai, sans-serif"
        },
        plotOptions: {
          bar: { horizontal: true, barHeight: "70%", borderRadius: 4 }
        },
        colors: ["#3B82F6", "#22C55E", "#8B5CF6"],
        xaxis: { categories: [] },
        yaxis: { labels: { style: { fontSize: "11px" }, maxWidth: 220 } },
        legend: { position: "top" },
        tooltip: { y: { formatter: val => val + " คน" } },
        dataLabels: { enabled: false }
      },

      // Chart: ภารกิจ workgroup
      workgroupChartLoading: false,
      workgroupChartSeries: [],
      workgroupChartOptions: {
        chart: {
          type: "bar",
          toolbar: { show: true, tools: { download: true } },
          fontFamily: "Sarabun, Noto Sans Thai, sans-serif"
        },
        plotOptions: {
          bar: { horizontal: true, barHeight: "65%", borderRadius: 4 }
        },
        colors: ["#F59E0B"],
        xaxis: { categories: [] },
        yaxis: { labels: { style: { fontSize: "11px" }, maxWidth: 200 } },
        legend: { position: "top" },
        tooltip: { y: { formatter: val => val + " คน" } },
        dataLabels: { enabled: true, style: { fontSize: "11px" } }
      }
    };
  },

  computed: {
    showHeaders() {
      return this.headers.filter(s => this.selectedHeaders.includes(s));
    },

    // จังหวัดที่กรองตามภาคที่เลือก
    provincesByRegion() {
      if (!this.selectedRegion) return this.provinces;
      return this.provinces.filter(
        p => String(p.region_ID) === String(this.selectedRegion)
      );
    },

    areaFilterActive() {
      return !!this.selectedRegion || !!this.selectedProvince;
    },
    areaFilterLabel() {
      const r = this.regions.find(
        x => String(x.region_ID) === String(this.selectedRegion)
      );
      const p = this.provinces.find(
        x => String(x.province_ID) === String(this.selectedProvince)
      );
      const parts = [];
      if (r) parts.push("ภาค" + r.region_name);
      if (p) parts.push("จ." + p.province_name);
      return parts.join(" / ") || "ทั้งหมด";
    },

    // กรองฝั่ง client: ประเภท + ช่วยราชการ
    filteredPersonnel() {
      let data = Array.isArray(this.personnel_etcs) ? this.personnel_etcs : [];
      if (this.filterType) {
        data = data.filter(p => p.personnel_etc_m_type === this.filterType);
      }
      if (this.filterHelpStatus) {
        if (this.filterHelpStatus === "normal") {
          data = data.filter(
            p =>
              !p.personnel_etc_help_status ||
              p.personnel_etc_help_status === "-"
          );
        } else {
          data = data.filter(
            p => p.personnel_etc_help_status === this.filterHelpStatus
          );
        }
      }
      return data;
    },

    summaryCards() {
      var c = this.personnel_etcsCounts;
      return [
        {
          label: "ผู้อำนวยการ",
          type: "director",
          count: c.directors || 0,
          icon: "mdi-account-star",
          theme: "cyan"
        },
        {
          label: "รองผู้อำนวยการ",
          type: "se_director",
          count: c.se_directors || 0,
          icon: "mdi-account-tie",
          theme: "teal"
        },
        {
          label: "ข้าราชการครู",
          type: "teacher",
          count: c.teachers || 0,
          icon: "mdi-human-male-board",
          theme: "blue"
        },
        {
          label: "38 ค.(2)",
          type: "38",
          count: c.support_38 || 0,
          icon: "mdi-account-cog",
          theme: "indigo"
        },
        {
          label: "ลูกจ้างประจำ",
          type: "permanent",
          count: c.permanents || 0,
          icon: "mdi-account-check",
          theme: "amber"
        },
        {
          label: "พนง.ราชการ(สอน)",
          type: "governmentteach",
          count: c.governmentteach || 0,
          icon: "mdi-teach",
          theme: "green"
        },
        {
          label: "พนง.ราชการ(สนับสนุน)",
          type: "governmentsp",
          count: c.governmentsp || 0,
          icon: "mdi-account-wrench",
          theme: "emerald"
        },
        {
          label: "ครูอัตราจ้าง",
          type: "temporary",
          count: c.temporarys || 0,
          icon: "mdi-account-clock",
          theme: "purple"
        },
        {
          label: "ลูกจ้างชั่วคราว",
          type: "temporary_job",
          count: c.temporary_jobs || 0,
          icon: "mdi-account-alert",
          theme: "rose"
        }
      ];
    },
    helpPersonnel() {
      return this.personnel_etcs.filter(
        p =>
          p.personnel_etc_help_status === "helping" ||
          p.personnel_etc_help_status === "receiving"
      );
    },
    helpStats() {
      var list = this.personnel_etcs;
      return {
        totalHelping: list.filter(
          p => p.personnel_etc_help_status === "helping"
        ).length,
        totalReceiving: list.filter(
          p => p.personnel_etc_help_status === "receiving"
        ).length
      };
    }
  },

  async created() {
    this.headers = Object.values(this.headersMap);
    this.selectedHeaders = this.headers;
  },

  async mounted() {
    await Promise.all([
      this.personnel_etcsQueryHelp(),
      this.workgroupQuery(),
      this.collegeQuery(),
      this.regionQuery(),
      this.provinceQuery(),
      this.rate_work_course_stdsQueryAll(),
      this.personnel_etcsCount(),
      this.subject_typeQuery(),
      this.personnel_reqReqNTBQuery(),
      this.personnel_reqReqOTBQuery()
    ]);
    this.loadCourseStats();
    this.loadWorkgroupStats();
  },

  methods: {
    // ========================================
    // Helper methods
    // ========================================
    getPersonnelTypeLabel(type) {
      var found = this.personnelTypeMap[type];
      return found ? found.label : "ยังไม่ได้กำหนดประเภท";
    },
    getPersonnelTypeClass(type) {
      var found = this.personnelTypeMap[type];
      return found ? found.css : "red--text";
    },
    getPersonnelChipColor(type) {
      var found = this.personnelTypeMap[type];
      return found ? found.color : "#EF4444";
    },
    getPersonnelTypeIcon(type) {
      return this.personnelTypeIconMap[type] || "mdi-account";
    },
    getSubjectLabel(code) {
      return this.subjectMap[code] || code;
    },
    getBudgetLabel(val) {
      if (val === "budget") return "จากงบประมาณ";
      if (val === "income") return "จากรายได้สถานศึกษา";
      return "";
    },
    isTemporary(type) {
      return ["temporary", "temporary_job"].includes(type);
    },
    isTeachingType(type) {
      return ["teacher", "governmentteach", "temporary"].includes(type);
    },
    isTeachingTypeOrGovSP(type) {
      return [
        "teacher",
        "governmentteach",
        "governmentsp",
        "temporary"
      ].includes(type);
    },
    isGovType(type) {
      return ["teacher", "se_director", "director", "38", "gov_em"].includes(
        type
      );
    },
    isLoginAllowed(type) {
      return [
        "temporary",
        "temporary_job",
        "governmentteach",
        "governmentsp",
        "permanent"
      ].includes(type);
    },
    showWorkgroup(type) {
      return [
        "permanent",
        "governmentteach",
        "governmentsp",
        "temporary_job"
      ].includes(type);
    },
    showIdPosition(type) {
      return [
        "permanent",
        "director",
        "se_director",
        "teacher",
        "supervision",
        "governmentteach",
        "governmentsp"
      ].includes(type);
    },
    showRankLevel(type) {
      return [
        "permanent",
        "director",
        "se_director",
        "teacher",
        "supervision"
      ].includes(type);
    },
    getCountForType(type) {
      var c = this.personnel_etcsCounts;
      var map = {
        director: c.directors,
        se_director: c.se_directors,
        teacher: c.teachers,
        "38": c.support_38,
        permanent: c.permanents,
        governmentteach: c.governmentteach,
        governmentsp: c.governmentsp,
        temporary: c.temporarys,
        temporary_job: c.temporary_jobs
      };
      return map[type] || 0;
    },

    // ===== workgroup หลายงาน (JSON) =====
    parseWorkgroups(wgValue) {
      if (!wgValue) return [];
      if (Array.isArray(wgValue)) return wgValue;
      try {
        var parsed = JSON.parse(wgValue);
        return Array.isArray(parsed) ? parsed : [wgValue];
      } catch (e) {
        return [wgValue];
      }
    },
    getWorkgroupName(wgId) {
      var found = this.workgroups.find(w => w.workGroupID === wgId);
      return found ? found.workGroupName : wgId;
    },

    // ========================================
    // Subject/Branch cascading
    // ========================================
    async fetchCoursesBySubject(subjectId) {
      this.rate_work_course_stds = [];
      this.rate_work_course_stdSubs = [];
      if (subjectId === "66") {
        var result = await this.$http.post("short_course.php", {
          ApiKey: this.ApiKey
        });
        this.rate_work_course_stds = result.data;
      } else {
        var result = await this.$http.post("rate_work_course_std.php", {
          ApiKey: this.ApiKey,
          id_type_course: subjectId
        });
        this.rate_work_course_stds = result.data;
      }
    },
    async fetchSubBranch(subjectId, branchId) {
      this.rate_work_course_stdSubs = [];
      if (subjectId === "66") {
        var result = await this.$http.post("short_course.php", {
          ApiKey: this.ApiKey,
          short_courseSTBranchID: branchId
        });
        this.rate_work_course_stdSubs = result.data;
      } else {
        var result = await this.$http.post("rate_work_course_std.php", {
          ApiKey: this.ApiKey,
          id_course_branch: branchId,
          searchGroupID: "Ok"
        });
        this.rate_work_course_stdSubs = result.data;
      }
    },
    onSubjectChangeEdit() {
      this.fetchCoursesBySubject(this.editpersonnel_etc.personnel_etc_subject);
    },
    onBranchChangeEdit() {
      this.fetchSubBranch(
        this.editpersonnel_etc.personnel_etc_subject,
        this.editpersonnel_etc.personnel_etc_branch
      );
    },

    // ========================================
    // Data queries
    // ========================================
    async workgroupQuery() {
      var result = await this.$http.post("workgroup.php", {
        ApiKey: this.ApiKey
      });
      this.workgroups = result.data;
    },
    async collegeQuery() {
      var result = await this.$http.post("college.php", {
        ApiKey: this.ApiKey
      });
      this.colleges = result.data;
    },
    async subject_typeQuery() {
      var result = await this.$http.post("subject_type.php", {
        ApiKey: this.ApiKey
      });
      this.subject_types = result.data;
    },
    async rate_work_course_stdsQueryAll() {
      var result = await this.$http.post("rate_work_course_std.php", {
        ApiKey: this.ApiKey
      });
      this.rate_work_course_stds = result.data;
    },

    // ===== โหลด ภาค / จังหวัด (ใหม่) =====
    async regionQuery() {
      try {
        var result = await this.$http.post("region.php", {
          ApiKey: this.ApiKey
        });
        this.regions = Array.isArray(result.data) ? result.data : [];
      } catch (e) {
        this.regions = [];
      }
    },
    async provinceQuery() {
      try {
        var result = await this.$http.post("province.php", {
          ApiKey: this.ApiKey
        });
        this.provinces = Array.isArray(result.data) ? result.data : [];
      } catch (e) {
        this.provinces = [];
      }
    },

    async personnel_etcsQueryHelp() {
      var result = await this.$http.post("personnel_etc.php", {
        ApiKey: this.ApiKey,
        personnel_etc_help_status: "helping"
      });
      this.personnel_etcs = result.data;
    },

    async personnel_etcSearch() {
      // ค้นหาตามวิทยาลัย — ล้างตัวกรองภาค/จังหวัด เพื่อไม่ชนกัน
      this.selectedRegion = null;
      this.selectedProvince = null;
      this.loading = true;
      try {
        var [dataRes, countRes] = await Promise.all([
          this.$http.post("personnel_etc.php", {
            ApiKey: this.ApiKey,
            personnel_etc_college_code: this.collegeSearch
          }),
          this.$http.post("personnel_etc.php", {
            ApiKey: this.ApiKey,
            count_personnel: "Ok",
            personnel_etc_college_code: this.collegeSearch
          })
        ]);
        this.personnel_etcs = dataRes.data;
        this.personnel_etcsCounts = countRes.data;
        this.calcCountSum();
      } finally {
        this.loading = false;
      }
    },

    // ===== ค้นหาตาม ภาค / จังหวัด (ใหม่) =====
    async personnel_etcSearchByArea() {
      // ถ้าไม่มีทั้งภาคและจังหวัด ให้กลับไปแสดงข้อมูลช่วยราชการ
      if (!this.selectedRegion && !this.selectedProvince) {
        await this.personnel_etcsQueryHelp();
        return;
      }
      // ล้างการเลือกวิทยาลัยเพื่อไม่ชนกัน
      this.collegeSearch = "";
      this.loading = true;
      try {
        var payload = { ApiKey: this.ApiKey };
        if (this.selectedRegion) payload.filter_region_ID = this.selectedRegion;
        if (this.selectedProvince)
          payload.filter_province_ID = this.selectedProvince;
        var result = await this.$http.post("personnel_etc.php", payload);
        this.personnel_etcs = Array.isArray(result.data) ? result.data : [];
      } catch (e) {
        this.personnel_etcs = [];
        Swal.fire({
          icon: "warning",
          title: "ไม่สามารถดึงข้อมูลตามพื้นที่ได้",
          showConfirmButton: false,
          timer: 1500
        });
      } finally {
        this.loading = false;
      }
    },

    onRegionChange() {
      // เมื่อเปลี่ยนภาค ให้รีเซ็ตจังหวัดที่อยู่นอกภาค แล้วค้นหาใหม่
      if (this.selectedProvince) {
        var stillValid = this.provincesByRegion.some(
          p => String(p.province_ID) === String(this.selectedProvince)
        );
        if (!stillValid) this.selectedProvince = null;
      }
      this.personnel_etcSearchByArea();
    },

    clearAreaFilter() {
      this.selectedRegion = null;
      this.selectedProvince = null;
      this.personnel_etcsQueryHelp();
    },

    async personnel_etcsCount() {
      var result = await this.$http.post("personnel_etc.php", {
        ApiKey: this.ApiKey,
        count_personnel: "Ok"
      });
      this.personnel_etcsCounts = result.data;
      this.calcCountSum();
    },
    calcCountSum() {
      var sum = Object.values(this.personnel_etcsCounts).reduce(function(
        acc,
        val
      ) {
        return acc + (parseFloat(val) || 0);
      },
      0);
      this.$set(this.personnel_etcsCounts, "sumAll", sum);
    },
    async personnel_etcSearchSYS() {
      var result = await this.$http.post("personnel_etc.php", {
        ApiKey: this.ApiKey,
        personnel_etc_id_card: this.searchIDcard
      });
      this.personnel_etcSYSs = result.data;
      if (!result.data.personnel_etc_id_card) {
        Swal.fire({
          icon: "warning",
          title: "ไม่พบข้อมูลบุคคลดังกล่าว",
          showConfirmButton: false,
          timer: 1500
        });
      }
    },
    async personnel_reqReqNTBQuery() {
      var result = await this.$http.post("personnel_req.php", {
        ApiKey: this.ApiKey,
        personel_reqNewCollege: this.user.college_code
      });
      this.personnel_reqReqNTB = result.data;
    },
    async personnel_reqReqOTBQuery() {
      var result = await this.$http.post("personnel_req.php", {
        ApiKey: this.ApiKey,
        personel_reqOldCollege: this.user.college_code
      });
      this.personnel_reqReqOTB = result.data;
    },

    // ========================================
    // Swal helper
    // ========================================
    async sweetAlertLoading() {
      Swal.fire({
        title: "กำลังดำเนินการ...",
        timerProgressBar: true,
        didOpen: function() {
          Swal.showLoading();
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      });
    },

    // ========================================
    // Admin actions
    // ========================================
    async updateData_etc() {
      await this.sweetAlertLoading();
      this.personnel_etc_updates.ApiKey = this.ApiKey;
      var result = await this.$http.post(
        "personnel_etc.update_admin.php",
        this.personnel_etc_updates
      );
      Swal.close();
      if (result.data.status == true) {
        Swal.fire({
          title: "ดำเนินการข้อมูลเรียบร้อย",
          icon: "success",
          showConfirmButton: false,
          timer: 1500
        });
      } else {
        Swal.fire({
          icon: "warning",
          title: "ผิดพลาด",
          showConfirmButton: false,
          timer: 1500
        });
      }
    },

    async delFormatFail() {
      await this.sweetAlertLoading();
      var results = await Promise.all([
        this.$http.post("personnel_etc.clearFail.php", { ApiKey: this.ApiKey }),
        this.$http.post("personnel_etc.clearFail2.php", {
          ApiKey: this.ApiKey
        }),
        this.$http.post("personnel_etc.clearFail3.php", { ApiKey: this.ApiKey })
      ]);
      Swal.close();
      var lastResult = results[2];
      if (lastResult.data.status == true) {
        Swal.fire({
          title: "ดำเนินการข้อมูลเรียบร้อย",
          icon: "success",
          showConfirmButton: false,
          timer: 1500
        });
      }
    },

    // ========================================
    // Login as user
    // ========================================
    async userLogin(personnel_etc_id_card, personnel_etc_pass) {
      var result = await this.$http.post("login_etc.php?crud=user", {
        personnel_etc_id_card: personnel_etc_id_card,
        personnel_etc_pass: personnel_etc_pass
      });
      if (result.data.personnel_etc_m_type) {
        var user = result.data;
        user.system_lock = false;
        localStorage.setItem("user", JSON.stringify(user));
        if (this.isLoginAllowed(user.personnel_etc_m_type)) {
          this.$router.push("/userEtc");
        } else {
          localStorage.clear();
        }
      }
    },

    // ========================================
    // Approve / Cancel requests
    // ========================================
    async personnel_reqApprove(personel_reqIDcard) {
      var result = await this.$http.post("personnel_req.php", {
        ApiKey: this.ApiKey,
        personel_reqIDcard: personel_reqIDcard
      });
      var reqData = result.data;
      var personnelApp =
        reqData.personnel_etc_title +
        reqData.personnel_etc_fristname +
        " " +
        reqData.personnel_etc_lastname;

      var confirm = await Swal.fire({
        title: "อนุมัติย้ายข้อมูลบุคคล",
        text: personnelApp,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก"
      });
      if (!confirm.isConfirmed) return;

      await this.sweetAlertLoading();
      var [resultUpdate, resultDel] = await Promise.all([
        this.$http.post("personnel_etc.updateMove.php", {
          ApiKey: this.ApiKey,
          personnel_etc_id_card: reqData.personel_reqIDcard,
          personnel_etc_college_code: reqData.personel_reqNewCollege
        }),
        this.$http.post("personnel_req.delete.php", {
          ApiKey: this.ApiKey,
          personel_reqIDcard: reqData.personel_reqIDcard
        })
      ]);
      Swal.close();

      if (resultDel.data.status == true && resultUpdate.data.status == true) {
        Swal.fire({
          title: "ดำเนินการข้อมูลเรียบร้อย",
          icon: "success",
          showConfirmButton: false,
          timer: 1500
        });
        this.reloadCurrentView();
        this.personnel_reqReqNTBQuery();
        this.personnel_reqReqOTBQuery();
      } else {
        Swal.fire({
          icon: "warning",
          title: "ผิดพลาด",
          showConfirmButton: false,
          timer: 1500
        });
      }
    },

    async cancelReg(personel_reqNewCollege, personel_reqIDcard) {
      var confirm = await Swal.fire({
        title: "ยกเลิกรายการร้องขอ",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก"
      });
      if (!confirm.isConfirmed) return;

      await this.sweetAlertLoading();
      var resultDel = await this.$http.post(
        "personnel_req.delete.college.php",
        {
          ApiKey: this.ApiKey,
          personel_reqNewCollege: personel_reqNewCollege,
          personel_reqIDcard: personel_reqIDcard
        }
      );
      Swal.close();

      if (resultDel.data.status == true) {
        Swal.fire({
          title: "ดำเนินการข้อมูลเรียบร้อย",
          icon: "success",
          showConfirmButton: false,
          timer: 1500
        });
        this.reloadCurrentView();
        this.personnel_reqReqNTBQuery();
        this.personnel_reqReqOTBQuery();
      } else {
        Swal.fire({
          icon: "warning",
          title: "ผิดพลาด",
          showConfirmButton: false,
          timer: 1500
        });
      }
    },

    // โหลดข้อมูลตารางใหม่ตามบริบทที่กำลังดูอยู่
    reloadCurrentView() {
      if (this.areaFilterActive) {
        this.personnel_etcSearchByArea();
      } else if (this.collegeSearch) {
        this.personnel_etcSearch();
      } else {
        this.personnel_etcsQueryHelp();
      }
    },

    // ========================================
    // CRUD
    // ========================================
    async personnel_etcEdit(personnel_etcIDNO) {
      var result = await this.$http.post("personnel_etc.php", {
        ApiKey: this.ApiKey,
        personnel_etcIDNO: personnel_etcIDNO
      });
      this.editpersonnel_etc = result.data;

      // แปลง workgroup JSON เป็น array สำหรับ multi-select
      if (typeof this.editpersonnel_etc.personnel_etc_workgroup === "string") {
        try {
          this.editpersonnel_etc.personnel_etc_workgroup = JSON.parse(
            this.editpersonnel_etc.personnel_etc_workgroup
          );
        } catch (e) {
          var val = this.editpersonnel_etc.personnel_etc_workgroup;
          this.editpersonnel_etc.personnel_etc_workgroup = val ? [val] : [];
        }
      }

      // โหลดสาขาวิชา/สาขางาน ตามค่าที่บันทึกไว้
      if (this.editpersonnel_etc.personnel_etc_subject) {
        await this.fetchCoursesBySubject(
          this.editpersonnel_etc.personnel_etc_subject
        );
      }
      if (this.editpersonnel_etc.personnel_etc_branch) {
        await this.fetchSubBranch(
          this.editpersonnel_etc.personnel_etc_subject,
          this.editpersonnel_etc.personnel_etc_branch
        );
      }

      this.editpersonnel_etcdialog = true;
    },

    async editpersonnel_etcSubmit() {
      if (!this.$refs.editpersonnel_etcform.validate()) return;
      this.editpersonnel_etc.ApiKey = this.ApiKey;

      if (!this.editpersonnel_etc.personnel_etc_help_status) {
        this.editpersonnel_etc.personnel_etc_help_college_code = null;
        this.editpersonnel_etc.personnel_etc_help_date = null;
      }

      var result = await this.$http.post(
        "personnel_etc.update.php",
        this.editpersonnel_etc
      );
      if (result.data.status == true) {
        Swal.fire({
          icon: "success",
          title: "แก้ไขข้อมูลเรียบร้อย",
          showConfirmButton: false,
          timer: 1500
        });
        this.reloadCurrentView();
        this.personnel_etcsCount();
      } else {
        Swal.fire({
          icon: "warning",
          title: "แก้ไขข้อมูลผิดพลาด",
          showConfirmButton: false,
          timer: 1500
        });
      }
      this.editpersonnel_etcdialog = false;
    },

    async personnel_etcDelete(personnel_etcIDNO) {
      var result = await this.$http.post("personnel_etc.php", {
        ApiKey: this.ApiKey,
        personnel_etcIDNO: personnel_etcIDNO
      });
      this.editpersonnel_etc = result.data;
      this.deletepersonnel_etcdialog = true;
    },

    async deletepersonnel_etcubmit() {
      if (!this.$refs.deletepersonnel_etcform.validate()) return;
      this.editpersonnel_etc.ApiKey = this.ApiKey;
      var result = await this.$http.post(
        "personnel_etc.delete.php",
        this.editpersonnel_etc
      );
      if (result.data.status == true) {
        Swal.fire({
          icon: "success",
          title: "ลบข้อมูลเรียบร้อย",
          showConfirmButton: false,
          timer: 1500
        });
        this.reloadCurrentView();
        this.personnel_etcsCount();
      } else {
        Swal.fire({
          icon: "warning",
          title: "ลบข้อมูลผิดพลาด",
          showConfirmButton: false,
          timer: 1500
        });
      }
      this.deletepersonnel_etcdialog = false;
    },

    // ========================================
    // ส่งออก Excel แยกตามประเภท
    // ========================================
    async loadXLSX() {
      if (!window.XLSX) {
        await new Promise(function(resolve, reject) {
          var script = document.createElement("script");
          script.src =
            "https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js";
          script.onload = resolve;
          script.onerror = reject;
          document.head.appendChild(script);
        });
      }
    },

    async fetchExportData(exportType) {
      var allData = [];
      var page = 1;
      var perPage = 5000;
      var totalPages = 1;

      while (page <= totalPages) {
        var payload = {
          ApiKey: this.ApiKey,
          export_type: exportType,
          page: page,
          per_page: perPage
        };
        // ส่งตัวกรองภาค/จังหวัดไปด้วย (ถ้ามี)
        if (this.selectedRegion) payload.filter_region_ID = this.selectedRegion;
        if (this.selectedProvince)
          payload.filter_province_ID = this.selectedProvince;

        var result = await this.$http.post("personnel_etc.php", payload);
        var resp = result.data;
        if (resp.status && resp.data) {
          allData = allData.concat(resp.data);
          totalPages = resp.total_pages;
          this.exportProgress.percent = Math.round((page / totalPages) * 100);
          this.exportProgress.text =
            "กำลังดึงข้อมูล " +
            this.getPersonnelTypeLabel(exportType) +
            " (" +
            page +
            "/" +
            totalPages +
            ")";
        } else {
          break;
        }
        page++;
      }
      return allData;
    },

    formatExportRow(item) {
      var self = this;
      return {
        ภาค: item.region_name || "",
        จังหวัด: item.province_name || "",
        วิทยาลัย: item.college_name || item.personnel_etc_college_code || "",
        ประเภทบุคลากร: self.getPersonnelTypeLabel(item.personnel_etc_m_type),
        รหัสบัตรประชาชน: item.personnel_etc_id_card,
        คำนำหน้า: item.personnel_etc_title,
        ชื่อ: item.personnel_etc_fristname,
        นามสกุล: item.personnel_etc_lastname,
        เลขที่ตำแหน่ง: item.personnel_etc_id_position || "",
        "อันดับ/ระดับ": item.personnel_etc_level || "",
        วิทยฐานะ: item.personnel_etc_rang || "",
        เงินเดือน: item.personnel_etc_salary || "",
        สาขาวิชา: item.personnel_etc_branch_n || "",
        สาขางาน: item.personnel_etc_branch_Subn || "",
        "ชม.สอน ภ.1": item.personnel_etc_teach_hours_s1 || "",
        "ชม.สอน ภ.2": item.personnel_etc_teach_hours_s2 || "",
        "วุฒิ ต่ำกว่า ป.ตรี":
          item.below_bachelor || item.personnel_etc_education_1 || "",
        "วุฒิ ปริญญาตรี":
          item.bachelor_degree || item.personnel_etc_education_2 || "",
        "วุฒิ ปริญญาโท":
          item.master_degree || item.personnel_etc_education_3 || "",
        "วุฒิ ปริญญาเอก":
          item.doctoral_degree || item.personnel_etc_education_4 || "",
        โทรศัพท์: item.personnel_etc_tel || "",
        อีเมล: item.personnel_etc_email || ""
      };
    },

    exportColumnWidths() {
      return [
        { wch: 12 },
        { wch: 15 },
        { wch: 30 },
        { wch: 25 },
        { wch: 15 },
        { wch: 10 },
        { wch: 15 },
        { wch: 15 },
        { wch: 12 },
        { wch: 12 },
        { wch: 15 },
        { wch: 12 },
        { wch: 20 },
        { wch: 20 },
        { wch: 10 },
        { wch: 10 },
        { wch: 25 },
        { wch: 25 },
        { wch: 25 },
        { wch: 25 },
        { wch: 15 },
        { wch: 25 }
      ];
    },

    async exportExcelByType(exportType) {
      await this.loadXLSX();
      this.exportingType = exportType;
      this.exportProgress = {
        show: true,
        text: "เริ่มดึงข้อมูล...",
        percent: 0
      };

      try {
        var data = await this.fetchExportData(exportType);
        if (!data || data.length === 0) {
          Swal.fire({
            icon: "info",
            title: "ไม่มีข้อมูลประเภทนี้",
            showConfirmButton: false,
            timer: 1500
          });
          return;
        }

        this.exportProgress.text = "กำลังสร้างไฟล์ Excel...";
        this.exportProgress.percent = 95;

        var self = this;
        var exportData = data.map(function(item) {
          return self.formatExportRow(item);
        });

        var wb = window.XLSX.utils.book_new();
        var ws = window.XLSX.utils.json_to_sheet(exportData);
        ws["!cols"] = this.exportColumnWidths();
        var label = this.getPersonnelTypeLabel(exportType);
        window.XLSX.utils.book_append_sheet(wb, ws, label.substring(0, 31));

        var areaTag = this.areaFilterActive
          ? "_" + this.areaFilterLabel.replace(/[\\/:*?\[\]]/g, "")
          : "";
        var filename =
          "personnel_" +
          exportType +
          areaTag +
          "_" +
          new Date().toISOString().slice(0, 10) +
          ".xlsx";
        window.XLSX.writeFile(wb, filename);

        this.exportProgress.percent = 100;
        this.exportProgress.text = "เสร็จสิ้น!";

        Swal.fire({
          icon: "success",
          title: "ส่งออก " + label + " เรียบร้อย (" + data.length + " รายการ)",
          showConfirmButton: false,
          timer: 2000
        });
      } catch (err) {
        console.error("Export error:", err);
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาดในการส่งออก",
          text: err.message || "",
          showConfirmButton: true
        });
      } finally {
        this.exportingType = null;
        var self = this;
        setTimeout(function() {
          self.exportProgress.show = false;
        }, 2000);
      }
    },

    async exportExcelAll() {
      await this.loadXLSX();
      this.exportingType = "all";
      this.exportProgress = {
        show: true,
        text: "เริ่มดึงข้อมูลทั้งหมด...",
        percent: 0
      };

      try {
        var wb = window.XLSX.utils.book_new();
        var types = this.exportTypes;
        var self = this;

        for (var i = 0; i < types.length; i++) {
          var t = types[i];
          self.exportProgress.text =
            "กำลังดึง " + t.label + " (" + (i + 1) + "/" + types.length + ")";
          self.exportProgress.percent = Math.round(
            ((i + 1) / types.length) * 90
          );

          var data = await self.fetchExportData(t.value);
          if (data && data.length > 0) {
            var exportData = data.map(function(item) {
              return self.formatExportRow(item);
            });
            var ws = window.XLSX.utils.json_to_sheet(exportData);
            ws["!cols"] = self.exportColumnWidths();
            window.XLSX.utils.book_append_sheet(
              wb,
              ws,
              t.label.substring(0, 31)
            );
          }
        }

        self.exportProgress.text = "กำลังสร้างไฟล์ Excel...";
        self.exportProgress.percent = 95;

        var areaTag = this.areaFilterActive
          ? "_" + this.areaFilterLabel.replace(/[\\/:*?\[\]]/g, "")
          : "";
        var filename =
          "personnel_all" +
          areaTag +
          "_" +
          new Date().toISOString().slice(0, 10) +
          ".xlsx";
        window.XLSX.writeFile(wb, filename);

        self.exportProgress.percent = 100;
        self.exportProgress.text = "เสร็จสิ้น!";

        Swal.fire({
          icon: "success",
          title: "ส่งออกข้อมูลทั้งหมดเรียบร้อย",
          showConfirmButton: false,
          timer: 2000
        });
      } catch (err) {
        console.error("Export all error:", err);
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: err.message || "",
          showConfirmButton: true
        });
      } finally {
        this.exportingType = null;
        var self = this;
        setTimeout(function() {
          self.exportProgress.show = false;
        }, 2000);
      }
    },

    // ส่งออกเฉพาะตารางที่กำลังแสดง (หลังกรอง) — ใช้ข้อมูลที่โหลดมาแล้ว ไม่ยิง API ซ้ำ
    async exportCurrentView() {
      await this.loadXLSX();
      var rows = this.filteredPersonnel;
      if (!rows || rows.length === 0) {
        Swal.fire({
          icon: "info",
          title: "ไม่มีข้อมูลในตาราง",
          showConfirmButton: false,
          timer: 1500
        });
        return;
      }
      var self = this;
      var exportData = rows.map(function(item) {
        return self.formatExportRow(item);
      });
      var wb = window.XLSX.utils.book_new();
      var ws = window.XLSX.utils.json_to_sheet(exportData);
      ws["!cols"] = this.exportColumnWidths();
      window.XLSX.utils.book_append_sheet(wb, ws, "ข้อมูลที่แสดง");

      var areaTag = this.areaFilterActive
        ? "_" + this.areaFilterLabel.replace(/[\\/:*?\[\]]/g, "")
        : "";
      var filename =
        "personnel_view" +
        areaTag +
        "_" +
        new Date().toISOString().slice(0, 10) +
        ".xlsx";
      window.XLSX.writeFile(wb, filename);

      Swal.fire({
        icon: "success",
        title: "ส่งออกตารางเรียบร้อย (" + rows.length + " รายการ)",
        showConfirmButton: false,
        timer: 1800
      });
    },

    // ========================================
    // ApexChart: สถิติสายการสอน
    // ========================================
    async loadCourseStats() {
      this.courseChartLoading = true;
      try {
        var result = await this.$http.post("personnel_etc.php", {
          ApiKey: this.ApiKey,
          chart_course_stats: "Ok"
        });
        var rawData = result.data;

        var categories = [];
        var teacherData = [];
        var govTeachData = [];
        var temporaryData = [];

        if (Array.isArray(rawData)) {
          rawData.forEach(function(item) {
            var label =
              item.rate_work_level_class + " - " + item.branch_name_th ||
              "ไม่ระบุ";
            if (label.length > 35) label = label.substring(0, 32) + "...";
            categories.push(label);
            teacherData.push(parseInt(item.count_teacher) || 0);
            govTeachData.push(parseInt(item.count_govteach) || 0);
            temporaryData.push(parseInt(item.count_temporary) || 0);
          });
        }

        this.courseChartSeries = [
          { name: "ข้าราชการครู", data: teacherData },
          { name: "พนง.ราชการ(สอน)", data: govTeachData },
          { name: "ครูอัตราจ้าง", data: temporaryData }
        ];

        this.courseChartOptions = Object.assign({}, this.courseChartOptions, {
          xaxis: { categories: categories }
        });
      } catch (err) {
        console.error("Load course stats error:", err);
      } finally {
        this.courseChartLoading = false;
      }
    },

    // ========================================
    // ApexChart: สถิติภารกิจ workgroup
    // ========================================
    async loadWorkgroupStats() {
      this.workgroupChartLoading = true;
      try {
        var result = await this.$http.post("personnel_etc.php", {
          ApiKey: this.ApiKey,
          chart_workgroup_stats: "Ok"
        });
        var resp = result.data;
        var rawData = resp.data || [];

        var filtered = rawData.filter(function(item) {
          return item.total > 0;
        });
        filtered.sort(function(a, b) {
          return b.total - a.total;
        });

        var categories = [];
        var seriesData = [];

        filtered.forEach(function(item) {
          var label = item.workGroupName || "ไม่ระบุ";
          if (label.length > 30) label = label.substring(0, 27) + "...";
          categories.push(label);
          seriesData.push(item.total);
        });

        this.workgroupChartSeries = [
          { name: "จำนวนบุคลากร", data: seriesData }
        ];

        this.workgroupChartOptions = Object.assign(
          {},
          this.workgroupChartOptions,
          {
            xaxis: { categories: categories }
          }
        );
      } catch (err) {
        console.error("Load workgroup stats error:", err);
      } finally {
        this.workgroupChartLoading = false;
      }
    },

    // ========================================
    // Row highlighting
    // ========================================
    row_classes(item) {
      if (!item.personnel_etc_m_type) return "row-highlight-error";
      if (
        !item.personnel_etc_subject &&
        ["teacher", "temporary", "governmentteach"].includes(
          item.personnel_etc_m_type
        )
      ) {
        return "row-highlight-warning";
      }
      // ปีหลักสูตรต่ำกว่า 2567 (ยกเว้นระยะสั้น)
      if (
        this.isTeachingType(item.personnel_etc_m_type) &&
        item.personnel_etc_subject &&
        item.personnel_etc_subject !== "66"
      ) {
        var yr = parseInt(item.year_course);
        if (!yr || yr < 2567) return "row-highlight-outdated";
      }
    }
  }
};
</script>

<style scoped>
/* ==========================================
   GLOBAL
   ========================================== */
.admin-dashboard {
  background: #f1f5f9;
  min-height: 100vh;
  font-family: "Sarabun", "Noto Sans Thai", sans-serif;
}

/* HEADER */
.dashboard-header {
  background: linear-gradient(135deg, #1e293b 0%, #334155 50%, #475569 100%);
  border-radius: 16px;
  padding: 24px 32px;
  box-shadow: 0 8px 32px rgba(30, 41, 59, 0.25);
  position: relative;
  overflow: hidden;
}
.dashboard-header::before {
  content: "";
  position: absolute;
  top: -50%;
  right: -10%;
  width: 300px;
  height: 300px;
  background: radial-gradient(
    circle,
    rgba(99, 102, 241, 0.15) 0%,
    transparent 70%
  );
  border-radius: 50%;
}
.dashboard-header::after {
  content: "";
  position: absolute;
  bottom: -40%;
  left: 20%;
  width: 200px;
  height: 200px;
  background: radial-gradient(
    circle,
    rgba(14, 165, 233, 0.1) 0%,
    transparent 70%
  );
  border-radius: 50%;
}
.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  position: relative;
  z-index: 1;
}
.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}
.header-icon-wrap {
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(99, 102, 241, 0.4);
}
.header-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
  letter-spacing: -0.02em;
}
.header-subtitle {
  font-size: 0.85rem;
  color: #94a3b8;
  margin: 4px 0 0;
}
.header-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.action-btn {
  border-radius: 10px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 0.8rem !important;
  letter-spacing: 0 !important;
  padding: 0 16px !important;
  height: 38px !important;
  box-shadow: none !important;
}
.green-btn {
  background: #22c55e !important;
  color: white !important;
}
.blue-btn {
  background: #3b82f6 !important;
  color: white !important;
}
.teal-btn {
  background: #14b8a6 !important;
  color: white !important;
}
.red-btn {
  background: #ef4444 !important;
  color: white !important;
}

/* STATS GRID */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 12px;
}
.stat-card {
  background: #ffffff;
  border-radius: 14px;
  padding: 16px 18px;
  display: flex;
  align-items: center;
  gap: 14px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  border: 1px solid #f1f5f9;
}
.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
}
.stat-card--total {
  grid-column: span 2;
  background: linear-gradient(135deg, #1e293b, #334155);
  border: none;
}
.stat-card--total .stat-card__value {
  color: #ffffff;
  font-size: 2rem;
}
.stat-card--total .stat-card__label {
  color: #94a3b8;
}
.stat-card__icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.stat-card--total .stat-card__icon {
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
}
.stat-card--cyan .stat-card__icon {
  background: linear-gradient(135deg, #06b6d4, #0ea5e9);
}
.stat-card--teal .stat-card__icon {
  background: linear-gradient(135deg, #14b8a6, #10b981);
}
.stat-card--blue .stat-card__icon {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
}
.stat-card--indigo .stat-card__icon {
  background: linear-gradient(135deg, #6366f1, #4f46e5);
}
.stat-card--amber .stat-card__icon {
  background: linear-gradient(135deg, #f59e0b, #d97706);
}
.stat-card--green .stat-card__icon {
  background: linear-gradient(135deg, #22c55e, #16a34a);
}
.stat-card--emerald .stat-card__icon {
  background: linear-gradient(135deg, #10b981, #059669);
}
.stat-card--purple .stat-card__icon {
  background: linear-gradient(135deg, #8b5cf6, #7c3aed);
}
.stat-card--rose .stat-card__icon {
  background: linear-gradient(135deg, #f43f5e, #e11d48);
}
.stat-card__info {
  display: flex;
  flex-direction: column;
}
.stat-card__value {
  font-size: 1.5rem;
  font-weight: 800;
  color: #1e293b;
  line-height: 1.1;
}
.stat-card__link {
  text-decoration: none !important;
  color: #1e293b !important;
  transition: color 0.15s;
}
.stat-card__link:hover {
  color: #6366f1 !important;
}
.stat-card__label {
  font-size: 0.75rem;
  color: #64748b;
  margin-top: 2px;
  font-weight: 500;
}

/* SECTION CARDS */
.section-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  border: 1px solid #f1f5f9;
}
.section-card__header {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}
.section-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}

/* HELP METRICS */
.help-metric {
  background: #f8fafc;
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  border: 1px solid #e2e8f0;
  transition: transform 0.15s;
}
.help-metric:hover {
  transform: scale(1.02);
}
.help-metric__number {
  font-size: 2.2rem;
  font-weight: 800;
  line-height: 1;
}
.help-metric--out .help-metric__number {
  color: #f97316;
}
.help-metric--in .help-metric__number {
  color: #14b8a6;
}
.help-metric--total .help-metric__number {
  color: #6366f1;
}
.help-metric__label {
  margin-top: 8px;
  font-size: 0.85rem;
  color: #64748b;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* REQUEST CARDS */
.request-card {
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  overflow: hidden;
}
.request-card__header {
  padding: 12px 16px;
  display: flex;
  align-items: center;
  font-size: 0.9rem;
}
.request-card--add .request-card__header {
  background: linear-gradient(90deg, #f0fdf4, #dcfce7);
  border-bottom: 1px solid #bbf7d0;
}
.request-card--move .request-card__header {
  background: linear-gradient(90deg, #fff7ed, #ffedd5);
  border-bottom: 1px solid #fed7aa;
}

/* SEARCH INPUT */
.search-input .v-input__slot {
  min-height: 42px !important;
}

/* MODERN TABLE */
.modern-table {
  border-radius: 12px !important;
  overflow: hidden;
}
.modern-table.v-data-table thead th {
  background: #f8fafc !important;
  color: #475569 !important;
  font-size: 0.8rem !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.03em !important;
  border-bottom: 2px solid #e2e8f0 !important;
  white-space: nowrap;
}
.modern-table.v-data-table tbody td {
  font-size: 0.85rem !important;
  color: #334155;
  border-bottom: 1px solid #f1f5f9 !important;
}
.modern-table.v-data-table tbody tr:hover {
  background: #f8fafc !important;
}

/* Row highlights */
.row-highlight-error {
  background: #fef2f2 !important;
}
.row-highlight-warning {
  background: #fffbeb !important;
}
.row-highlight-outdated {
  background: #fff1f2 !important;
}

/* DIALOGS */
.dialog-card {
  border-radius: 20px !important;
  overflow: hidden;
}
.dialog-card__header {
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 12px;
  color: white;
}
.dialog-card__header h3 {
  margin: 0;
  font-weight: 700;
  font-size: 1.15rem;
}
.dialog-card__header--danger {
  background: linear-gradient(135deg, #ef4444, #dc2626);
}
.dialog-card__header--edit {
  background: linear-gradient(135deg, #f59e0b, #d97706);
}

/* Delete Info Card */
.delete-info-card {
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 12px;
  padding: 20px;
  text-align: center;
}
.delete-info-card__id {
  font-size: 1rem;
  color: #ef4444;
  font-weight: 700;
  margin-bottom: 6px;
}
.delete-info-card__name {
  font-size: 1.1rem;
  color: #1e293b;
  font-weight: 600;
}

/* EDIT SECTIONS */
.edit-section {
  background: #f8fafc;
  border-radius: 12px;
  padding: 16px;
  border: 1px solid #e2e8f0;
}
.edit-section__title {
  font-size: 0.85rem;
  font-weight: 700;
  color: #475569;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
}

/* EXPORT LIST */
.export-list-item {
  border-radius: 10px;
  border: 1px solid #f1f5f9;
  transition: background 0.15s;
}
.export-list-item:hover {
  background: #f8fafc;
}

/* RESPONSIVE */
@media (max-width: 960px) {
  .dashboard-header {
    padding: 16px 20px;
  }
  .header-title {
    font-size: 1.15rem;
  }
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .stat-card--total {
    grid-column: span 2;
  }
  .header-actions {
    width: 100%;
  }
  .action-btn {
    flex: 1;
    min-width: 140px;
  }
}
@media (max-width: 600px) {
  .stats-grid {
    grid-template-columns: 1fr;
  }
  .stat-card--total {
    grid-column: span 1;
  }
  .section-card {
    padding: 16px;
  }
}
</style>
